import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import { SheetJSFT } from "./types";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import "./styles.css";
import { addAnalytics } from '../../../Common/analytics';
import exportToCSVNew from '../../../Common/exportcsvnew';

var url = window.location.hostname;
var port = window.location.port;





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.change = this.change.bind(this);
    this.fetchBinData = this.fetchBinData.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      basepack_header: [{ "Client": "", "Product Code": "", "Mrp": "", "Parent Product Code" : "", "Parent Mrp" : "" }],
      tester_header: [
        { "BasePack Code": "", "Basepack Description": "", "Bin": "" },
      ],
      product_master_header: [
        {
          "Company": "",
          "Brand": "",
          "Sub Brand": "",
          "LB SKU ID": "",
          "LB SKU Product Name": "",
          "Basepack Code": "",
          "BasePack Description": "",
          "CBU Code": "",
          "Shade Code": "",
          "Shade Name": "",
          "Category": "",
          "Sub-Category": "",
          "Price Lot": "",
          "MRP": "",
          "UOM": "",
          "UPC": "",
          "Pack Size": "",
          "Pack Size UOM": "",
          "EAN": "",
          "ICLD EAN": "",
      "Tester Code":"",
          "Weight": "",
          "Volume": "",
          "ICLD Volume": "",
          "SKU7 Code": "",
          "SKU5 Code": "",
          "Offer": "",
          "Tester": "",
          "Tester Ratio": "",
          "Storage Type": "",
          "Shelf Life (months)": "",
          "Status": "",
          "Created Date Time": "",
          "Barcode type": "",
          "CBU Tester Flag": "",
          "ICLD Width": "",
          "ICLD Height": "",
          "ICLD Depth": "",
          "OCLD EAN": "",
          "CPO": "",
          "OCLD Depth": "",
          "OCLD Flag": "",
          "OCLD Height": "",
          "OCLD Volume": "",
          "OCLD Width": "",
          "LB Type": "",
          "LB Type Analysis": "",
          "Updated Date Time": "",
          "Created By": "",
          "Updated By": "",
          "ID": "",
          "ICLD EAN Verified Status": "",
          "ICLD EAN Verified Date/Time": "",
          "OCLD EAN Verified Status": "",
          "OCLD EAN Verified Date/Time": "",
          "Reference LB SKU ID": "",
        },
      ],
      bin_master_header: [
        {
          "Storage type": "",
          "Aisle": "",
          "Rack": "",
          "Rack type": "",
          "Level": "",
          "Bin": "",
          "Bin Address": "",
          "Bin Volume": "",
          "Zone Name": "",
          "Zone No.": "",
          "Rack Address": "",
          "Bin Depth": "",
          "Bin Width": "",
          "Bin Height": "",
        },
      ],
      showPassword: false,
    responseModal: false,
    responseModalMsg: null,
    btnDisabled: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: "masterFile",
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      BinMasters: [
        "Aisle",
        "Bin",
        "Bin Address",
        "Level",
        "Rack",
        "Rack Type",
        "Storage Type",
        "Zone Name",
        "Zone No.",
      ],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes: [
        { "Base Pack Code": "fghj", "Zone Name": "fghj", "Zone No": "fghj" },
      ],
      zoneTypeDropdown: [],
      zoneConfigDropdown: [],
      configBaskPackDropdown: [],
      config_zonecode: null,
      config_zonename: null,
      config_zonetype: null,
      config_zoneconfig: null,
      config_basepackcode: null,
      config_producttype: null,
      showZoneConfigCard: false,
      zoneOptions: [],
      validation: {
        "Bin Master": {
          Aisle: "string",
          Bin: "number",
          "Bin Address": "string",
          Level: "number",
          Rack: "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          Company: "string",
          Brand: "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          Category: "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          MRP: "string",
          UOM: "string",
          UPC: "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          EAN: "string",
          "ICLD EAN": "string",
          Weight: "string",
          Volume: "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          Offer: "string",
          Tester: "string",
          "Storage Type": "string",
          Status: "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },

        "Tester Basepack Master": {
          "S. No.": "number",
          "BasePack Code": "string",
          "Basepack Description": "string",
          Bin: "string",
        },
      },
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
  this.setState({
    responseModal: !this.state.responseModal
  });
  }
  
  config_zoneDropDown = () => {
    axios
    .post(
        "http://" + url + "/inventory/fetchZoneConfigType/v1/",
        {
          location: this.state.selectedLocation,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )
      .then((response) => response.data)
    .then((data) => {
        this.setState({
      zoneTypeDropdown: data["zone_types"],
            zoneConfigDropdown: data["zone_config"],
            configBaskPackDropdown: data["base_pack_codes"],
    });
      })
      .catch(function (error) {});
  };

  configOnChangeHandler = (e) => {
    if(e.target.name === "config_zonecode"){
    this.setState({config_zonecode: e.target.value});
  }if(e.target.name === "config_zonename"){
    this.setState({config_zonename: e.target.value});
  }if(e.target.name === "config_zonetype"){
    this.setState({config_zonetype: e.target.value});
  }if(e.target.name === "config_zoneconfig"){
    this.setState({config_zoneconfig: e.target.value});
  }if(e.target.name === "config_basepackcode"){
    this.setState({config_basepackcode: e.target.value});
  }if(e.target.name === "config_producttype"){
    this.setState({config_producttype: e.target.value});
  }
  }

  zoneDropdown = () => {
    axios
    .post(
        "http://" + url + "/cycle_count/cycleCountParameters/v1/",
        //"http://" + url + "/cycle_count/cycleCountParameters/v1/",
        {
          location: this.state.selectedLocation,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )
      .then((response) => response.data) 
       .then((data) => {
        let zoneOptions = [...this.state.zoneOptions];
        for (var i = 0; i < data.zones.length; i++) {
          var orderData = {};
          orderData["label"] = data.zones[i].zone_code;
          orderData["value"] = data.zones[i].zone_no;
          orderData["id"] = data.zones[i].id;
          zoneOptions.push(orderData);
        }
        this.setState({
          zoneOptions: zoneOptions,
        }, () => {console.log(this.state.zoneOptions)});
      })
      .catch(function (error) {});
  };
  createZoneConfig = () => {
    if(this.state.config_zonecode === "" || this.state.config_zonecode === undefined){
    alert("Enter Zone Code");
        return false;
    }
    if(this.state.config_zonename === "" || this.state.config_zonename === undefined){
    alert("Enter Zone Name");
        return false;
    }
    if(this.state.config_zonetype === 0 || this.state.config_zonetype === undefined){
    alert("Select Zone Type");
        return false;
    }
    if(this.state.config_zoneconfig === 0 || this.state.config_zoneconfig === undefined){
    alert("Select Zone Config");
        return false;
    }
    if(this.state.config_basepackcode === 0 || this.state.config_basepackcode === undefined){
    alert("Select BasePack code");
        return false;
    }
    if(this.state.config_producttype === "" || this.state.config_producttype === undefined){
    alert("Select Product Type");
        return false;
    }
    axios
    .post(
        "http://" + url + "/inventory/zoneCreation/v1/",
        {
         location: this.state.selectedLocation,
    zone_type_id: this.state.config_zonetype,
    zone_config_id: this.state.config_zoneconfig,
    zone_name: this.state.config_zonename,
    zone_no: this.state.config_zonecode,
    base_pack_code: this.state.config_basepackcode,
    product_type: this.state.config_producttype
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )
      .then((response) => response.data)
    .then((data) => {
        if(data.status === true){
            this.setState({successCreatedMessage: "Updated Successfully",Successmodal: true})
        }
      })
      .catch(function (error) {});
  };
  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
        //this.config_zoneDropDown();
        //this.zoneDropdown();
      }
    );

    localStorage.setItem("userName", username);
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }/*,
      () => {
        if (document.getElementById("my_file_input") !== null) {
          document.getElementById("my_file_input").style.color = "transparent";
          document.getElementById("tester_label").style.display =
            "inline-block";
          document.getElementById("tester_label").innerHTML =
            "Select and Upload Master ";
      document.getElementById("my_file_input").style.width = "26%";
        }
        $(".upload_error").css("display", "none");
        $(".upload_success").css("display", "none");
      }*/
    );

    /*if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }*/
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  togglePressCancel() {
    

    this.setState({
      modal: false,
      modalFailed: false,
    });
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  fetchBinData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
    });

    axios
      .get(
        "http://" +
          url +
          "/inventory/bin_master/v1/?location=" +
          this.state.selectedLocation,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ posts: data });
      })

      .then(async () => {
        this.setState({ tableRows: this.assemblePosts(), isLoading: false });

        console.log(this.state.tableRows);
      });
  }

  fetchBaseData() {
    this.setState({
      showFetchBaseData: true,
      showFetchBinData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
    });

    axios
      .get(
        "http://" +
          url +
          "/inventory/base_pack_zone_code_master/v1/?location=" +
          this.state.selectedLocation,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsBase: data });
      })

      .then(async () => {
        this.setState({
          tableRowsBase: this.assemblePostsBase(),
          isLoading: false,
        });

        console.log(this.state.tableRowsBase);
      });
  }

  fetchProductData() {
    this.setState({
      showFetchBaseData: false,
      showFetchBinData: false,
      showFetchProductData: true,
      showFetchTesterData: false,
      loadingGRNData: true,
    });

    axios
      .get(
        "http://" +
          url +
          "/product/product_master/v1/?location=" +
          this.state.selectedLocation,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsProduct: data });
        console.log(this.state.postsProduct);
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          loadingGRNData: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  fetchTesterData() {
    this.setState({
      showFetchBaseData: false,
      showFetchBinData: false,
      showFetchProductData: false,
      showFetchTesterData: true,
      loadingGRNData: true,
    });

    axios
      .get(
        "http://" +
          url +
          "/inventory/testerBasePackZoneUtility/v1/?location=" +
          this.state.selectedLocation,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )

      .then((response) => response.data)

      .then((data) => {
        console.log(data);

        // if (err) throw err;

        this.setState({ postsTester: data });
        console.log(this.state.postsProduct);
      })

      .then(async () => {
        this.setState({
          tableRowsTester: this.assemblePostsTester(),
          isLoading: false,
          loadingGRNData: false,
        });

        console.log(this.state.tableRowsTester);
      });
  }

  assemblePosts = () => {
    let posts = this.state.posts.map((post) => {
      return {
        bin_id: post.bin,

        storage_type: post.storageType,

        aisle: post.aisle,

        rack: post.rack,

        rack_type: post.rackType,

        level: post.level,

        bin: post.binAddress,

        zone_name: post.zoneName,

        zone_number: post.zoneNumber,
      };
    });

    return posts;
  };

  assemblePostsBase = () => {
    let postsBase = this.state.postsBase.map((post) => {
      return {
        base_pack_code: post.basePackCode,

        zone_name: post.zoneName,

        zone_number: post.zoneNo,
        productType: post.productType,
      };
    });

    return postsBase;
  };

  assemblePostsProduct = () => {
    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
        company: post.company,

        brand: post.brand,

        sub_brand: post.subBrand,

        ib_sku_id: post.lbSkuId,

        ib_sku_product_name: post.lbSkuProductName,

        base_pack_code: post.basepackCode,

        cbu_code: post.cbuCode,

        shade_code: post.shadeCode,

        shade_name: post.shadeName,

        category: post.category,

        sub_category: post.subCategory,

        price_lot: post.priceLot,

        mrp: post.mrp,

        uom: post.uom,

        upc: post.upc,

        pack_size: post.packSize,

        pack_size_uo: post.packSizeUom,

        ean: post.ean,

        icld_ean: post.icldEAN,

        weight: post.weight,

        volume: post.volume,

        icldVolume: post.icldVolume,

        sku7Code: post.sku7Code,

        sku5Code: post.sku5Code,

        offer: post.offer,

        tester: post.tester,

        storageType: post.storageType,

        status: post.status,

        createdDateTime: post.createdDateTime,

        //updatedDateTime: post.updatedDateTime,
        outerCartonEAN: post.outerCartonEAN,
        cpo: post.cpo,
        cartonLength: post.cartonLength,
        cartonBreadth: post.cartonBreadth,
        cartonHeight: post.cartonHeight,
        cartonVolume: post.cartonVolume,
        ocldApplicable: post.ocldApplicable,
      };
    });

    return postsProduct;
  };

  assemblePostsTester = () => {
    console.log(this.state.postsTester);

    let postsTester = this.state.postsTester.map((post) => {
      return {
        base_pack_code: post.base_pack_code,

        bin: post.bin_address,
      };
    });

    return postsTester;
  };

  handleChange(evt) {
  const files = evt.target.files;
  var file1 = evt.target.value;
  this.setState({
    btnDisabled: true,
        loading_overlay: true,
  }, () => {
    
    if (files && files[0]) {
    this.setState({ 
    file: files[0] 
    })
  }else{
    this.setState({ 
    loading_overlay: false,
        btnDisabled: false,
        file:{},
    })
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
  };
    
    var fileArray1 = file1.split(".");
    var extension1 = fileArray1[fileArray1.length - 1];

    if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
      document.getElementById("my_file_input").style.width = "85%";
      document.getElementById("picking_label").style.display = "none";
    }else{
      document.getElementById("my_file_input").style.width = "26%";
    }

    if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
      $(".upload_error").css("display", "block");
      $(".upload_success").css("display", "none");
    } else {
      $(".upload_success").css("display", "block");
      $(".upload_error").css("display", "none");
      $(".button_enable").removeAttr("disabled", "disabled");
    }
    
    this.setState({
      btnDisabled: false,
            loading_overlay: false,
    });
  });
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showInvalidTesterItem: false,
      showRowDataErrorProduct: false,
      showRowDataErrorTester: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
      showZoneConfigCard: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");

    if (selectedOption.value === "bin_master") {
      //this.fetchBinData();
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchTesterData: false,
        showFetchProductData: false,
      });
    } else if (selectedOption.value === "base_pack_zone") {
      //this.fetchBaseData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: true,
        showFetchProductData: false,
        showFetchTesterData: false,
        showZoneConfigCard: true
      });
    } else if (selectedOption.value === "product_master") {
      //this.fetchProductData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: true,
        showFetchTesterData: false,
      });
    } else if (selectedOption.value === "tester_basepack_master") {
      //this.fetchTesterData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: true,
      });
    }

    console.log(`Option selected:`, selectedOption.value);
  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
    if (dataTypes === undefined) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    const keyNames = Object.keys(dataTypes);
    if (Object.keys(item).length !== keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true;
  };

  handleFile() {
    /* Boilerplate to set up FileReader */

   
  if(this.state.file.name === undefined || this.state.file.name === null){
    this.setState({
      responseModal: true,
      responseModalMsg: "Select at least one File"
    });
    return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
  const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD"
      });
      
    var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          wb.Sheets[wsname],
          { header: 1, blankRows: false }
        );
      var json_object = XL_row_object;

      
      var mandatory_field = false;
    var uploaded_file_header = json_object[0];

      /* if (this.state.selectedOption.value === "product_master") {
    var sample_file_header = Object.keys(this.state.product_master_header[0]);
    }else if (this.state.selectedOption.value === "base_pack_zone") {
    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    }else if (this.state.selectedOption.value === "tester_basepack_master") {
    var sample_file_header = Object.keys(this.state.tester_header[0]);
    }else if (this.state.selectedOption.value === "bin_master") {
    var sample_file_header = Object.keys(this.state.bin_master_header[0]);
    } */

    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    
    if(parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length) ){
      ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
                    loading_overlay: false,
        });
        /*if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');*/
        return false;
    } 
    for (let i = 0; i < uploaded_file_header.length; i++){
      if (uploaded_file_header[i] !== sample_file_header[i]){
       ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
                    loading_overlay: false,
        });
      return false;
      }
    }
      
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

        //if (this.state.selectedOption.value === "base_pack_zone") {
          if (invalidItems.length > 0) {
            console.log(invalidItems);
            this.setState({
              showRowDataErrorBase: false,
              showRowDataErrorProduct: false,
              showRowDataErrorTester: false,
              showRowDataError: false,
              showResponseData: true,
              ErrorRowData: invalidItems,
              showResponseData: false,
              showInvalidItem: false,
              showBaseResponseData: false,
              showInvalidBaseItem: false,
              showInvalidProductItem: false,
              showInvalidTesterItem: false,
              showProductResponseData: false,
              showFetchBaseData: false,
              showFetchProductData: false,
              showFetchTesterData: false,
              showFetchBinData: false,
            });

            console.log(Object.keys(invalidItems));
            /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

            /*return false*/
          }

          addAnalytics('Upload File', 'Upload Alternate', this.state.data);

          console.log(this.state.data.length);
          var arr = [];

          for (var i = 0; i < this.state.data.length; i++) {
            // <---- Move declaration inside loop

            var orderData = {};
            /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
            orderData["zoneName"] = this.state.data[i]["ZoneName"];
            orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

           if (
            this.state.data[i]["Client"] == undefined ||
            this.state.data[i]["Client"] == null
          ) {
            alert("Client cannot be null");
            this.setState({
              loading: false,
              loading_overlay: false,
            });
            return false;
            orderData["client"] = "";
          } else {
            orderData["client"] = this.state.data[i]["Client"];
          }

          if (
            this.state.data[i]["Product Code"] == undefined ||
            this.state.data[i]["Product Code"] == null
          ) {
            alert("Product code cannot be null");
            this.setState({
              loading: false,
              loading_overlay: false,
            });
            return false;
            orderData["sku7_code"] = "";
          } else {
            orderData["sku7_code"] = this.state.data[i]["Product Code"];
          }

          if (
            this.state.data[i]["Mrp"] == undefined ||
            this.state.data[i]["Mrp"] == null
          ) {
            alert("Mrp cannot be null");
            this.setState({
              loading: false,
              loading_overlay: false,
            });
            return false;
            orderData["mrp"] = "";
          } else {
            orderData["mrp"] = this.state.data[i]["Mrp"];
          }


           if (
            this.state.data[i]["Parent Product Code"] == undefined ||
            this.state.data[i]["Parent Product Code"] == null
          ) {
            alert("Parent Product Code cannot be null");
            this.setState({
              loading: false,
              loading_overlay: false,
            });
            return false;
            orderData["parent_sku"] = "";
            } else {
              orderData["parent_sku"] = this.state.data[i]["Parent Product Code"];
            }

             if (
            this.state.data[i]["Parent Mrp"] == undefined ||
            this.state.data[i]["Parent Mrp"] == null
            ) {
              alert("Parent Mrp cannot be null");
              this.setState({
                loading: false,
                loading_overlay: false,
              });
              return false;
              orderData["parent_mrp"] = "";
            } else {
              orderData["parent_mrp"] = this.state.data[i]["Parent Mrp"];
            }

            arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr);

          const payload = {
              "master_data": arr,
              "master_type": "alt_product_master", 

        };

          API.post("/product/upload/v1/", { param: payload })
            .then((response) => {
              console.log("responeData",response.data);


              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                show_process_data: true,
              });

              if(response.data.success == false){
                this.toggleFailed();
              }else{
                this.Successtoggle();
                this.setState({
                 successCreatedMessage: response.data.message
                })
              }

              /*if (response.data.failure_response.length > 0) {
                this.toggleFailed();
              } else {
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              } */
                this.setState({loading_overlay: false,})
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
      
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
      });
       

        

        

       

        /*}*/
      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }

  processData() {
    this.setState({
      loading: true,
    });

    if (this.state.selectedOption.value === "base_pack_zone") {
      console.log(this.state.data);
      var arr = [];

      for (var i = 0; i < this.state.data.length; i++) {
        // <---- Move declaration inside loop

        var orderData = {};
        orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
        orderData["zoneName"] = this.state.data[i]["ZoneName"];
        orderData["zoneNo"] = this.state.data[i]["ZoneNo"];

        arr.push(orderData);
      }

      console.log(arr);
      var arr_data = JSON.stringify(arr);

      axios
        .post(
          "http://" + url + "/inventory/base_pack_zone_code_master/v1/",

          {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
          },

          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.state.userName,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.setState({
            showBaseResponseData: true,
            showInvalidBaseItem: false,
            showResponseData: false,
            showInvalidItem: false,
            showProductResponseData: false,
            showTesterResponseData: false,
            showInvalidTesterItem: false,
            showRowDataErrorTester: false,
            showInvalidProductItem: false,
            showRowDataError: false,
            showRowDataErrorBase: false,
            showRowDataErrorProduct: false,
            modal: false,
            modalFailed: false,
            loading: false,
            responseFailBaseData: response.data,
            responseSuccessBaseData: response.data,
            successCreatedMessage: "BasePack Successfully Created",
            ConfirmModal: false,
            Successmodal: true,
          });

          /*alert("BasePack Successfully Created");*/

          /*this.toggleFailed();*/
          // this.fetchBaseData();
        })
        .catch(function (error) {});
    }

    if (this.state.selectedOption.value === "tester_basepack_master") {
      axios
        .post(
          "http://" + url + "/inventory/testerBasePackZoneUtility/v1/",

          {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
          },

          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.state.userName,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.setState({
            showBaseResponseData: false,
            showTesterResponseData: true,
            showInvalidBaseItem: false,
            showResponseData: false,
            showRowDataErrorTester: false,
            showInvalidTesterItem: false,
            showInvalidItem: false,
            showProductResponseData: false,
            showInvalidProductItem: false,
            showRowDataError: false,
            showRowDataErrorBase: false,
            showRowDataErrorProduct: false,
            modal: false,
            modalFailed: false,
            loading: false,
            responseFailBaseData: response.data,
            responseSuccessBaseData: response.data,
            successCreatedMessage: "Tester BasePack Successfully Created",
            ConfirmModal: false,
            Successmodal: true,
          });

          /*alert("BasePack Successfully Created");*/

          /*this.toggleFailed();*/
          // this.fetchTesterData();
        })
        .catch(function (error) {});
    }

    if (this.state.selectedOption.value === "product_master") {
      console.log(this.state.data);
      var arr = [];

      for (var i = 0; i < this.state.data.length; i++) {
        // <---- Move declaration inside loop

        var orderData = {};
        orderData["company"] = this.state.data[i]["Company"];
        orderData["brand"] = this.state.data[i]["Brand"];
        orderData["subBrand"] = this.state.data[i]["Sub Brand"];
        orderData["lbSkuId"] = this.state.data[i]["LB SKU ID"];
        orderData["lbSkuProductName"] = this.state.data[i][
          "LB SKU Product Name"
        ];
        orderData["basepackCode"] = this.state.data[i]["Basepack Code"];
        orderData["cbuCode"] = this.state.data[i]["CBU Code"];
        orderData["shadeCode"] = this.state.data[i]["Shade Code"];
        orderData["shadeName"] = this.state.data[i]["Shade Name"];
        orderData["category"] = this.state.data[i]["Category"];
        orderData["subCategory"] = this.state.data[i]["Sub-Category"];
        orderData["priceLot"] = this.state.data[i]["Price Lot"];
        orderData["mrp"] = this.state.data[i]["MRP"];
        orderData["uom"] = this.state.data[i]["UOM"];
        orderData["upc"] = this.state.data[i]["UPC"];
        orderData["packSize"] = this.state.data[i]["Pack Size"];
        orderData["packSizeUom"] = this.state.data[i]["Pack Size UOM"];
        orderData["ean"] = this.state.data[i]["EAN"];
        orderData["icldEAN"] = this.state.data[i]["ICLD EAN"];
        orderData["weight"] = this.state.data[i]["Weight"];
        orderData["volume"] = this.state.data[i]["Volume"];
        orderData["icldVolume"] = this.state.data[i]["ICLD Volume"];
        orderData["sku7Code"] = this.state.data[i]["SKU7 Code"];
        orderData["sku5Code"] = this.state.data[i]["SKU5 Code"];
        orderData["offer"] = this.state.data[i]["Offer"];
        orderData["tester"] = this.state.data[i]["Tester"];
        orderData["storageType"] = this.state.data[i]["Storage Type"];
        orderData["status"] = this.state.data[i]["Status"];
        orderData["createdDateTime"] = this.state.data[i]["Created Date Time"];
        orderData["updatedDateTime"] = this.state.data[i]["Updated Date Time"];

        arr.push(orderData);
      }

      console.log(arr);
      var arr_data = JSON.stringify(arr);

      axios
        .post(
          "http://" + url + "/product/product_master/v1/",

          {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
          },

          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.state.userName,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.setState({
            showBaseResponseData: false,
            loading: false,
            showProductResponseData: true,
            showTesterResponseData: false,
            showRowDataErrorTester: false,
            showInvalidTesterItem: false,
            showInvalidBaseItem: false,
            showResponseData: false,
            showInvalidItem: false,
            showInvalidProductItem: false,
            showRowDataError: false,
            showRowDataErrorBase: false,
            showRowDataErrorProduct: false,
            modalFailed: false,
            modal: false,
            //responseFailProductData: response.data,
            responseSuccessProductData: response.data,
            successCreatedMessage: "Product Master Successfully Created",
            ConfirmModal: false,
            Successmodal: true,
          });
          /*alert("Product Master Successfully Created");*/
          /*this.toggle();*/
          /* this.toggleFailed();*/
          // this.fetchProductData();
        })
        .catch(function (error) {});
    }

    if (this.state.selectedOption.value === "bin_master") {
      /*console.log(this.state.BinMasters.length);
              console.log(data.length);*/
      /*if (this.state.BinMasters.length != data.length) {
              alert("Invalid formate");
              let invalidItems = this.state.data.filter(item => !this.validateItem(item))
              console.log(invalidItems);
              return false;
            }*/

      var arr = [];

      for (var i = 0; i < this.state.data.length; i++) {
        // <---- Move declaration inside loop

        var orderData = {};
        orderData["storageType"] = this.state.data[i]["StorageType"];
        orderData["aisle"] = this.state.data[i]["Aisle"];
        orderData["rack"] = this.state.data[i]["Rack"];
        orderData["rackType"] = this.state.data[i]["RackType"];
        orderData["level"] = this.state.data[i]["Level"];
        orderData["binAddress"] = this.state.data[i]["BIN_ID"];
        orderData["binId"] = this.state.data[i]["Bin"];
        orderData["zoneName"] = this.state.data[i]["ZoneName"];
        orderData["zoneNo"] = this.state.data[i]["ZoneNo"];
        orderData["binVolume"] = 4;

        arr.push(orderData);
      }

      console.log(arr);
      var arr_data = JSON.stringify(arr);

      axios
        .post(
          "http://" + url + "/inventory/bin_master/v1/",

          {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
          },

          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.state.userName,
            },
          }
        )
        .then((response) => {
          console.log(response);

          this.setState({
            showResponseData: true,
            showInvalidItem: false,
            loading: false,
            showBaseResponseData: false,
            showTesterResponseData: false,
            showRowDataErrorTester: false,
            showInvalidTesterItem: false,
            showInvalidBaseItem: false,
            showInvalidProductItem: false,
            showProductResponseData: false,
            showRowDataError: false,
            showRowDataErrorBase: false,
            showRowDataError: false,
            modalFailed: false,
            modal: false,
            responseFailBinData: response.data,
            responseSuccessBinData: response.data,
            successCreatedMessage: "Bin Master Successfully Created",
            ConfirmModal: false,
            Successmodal: true,
          });
          /* this.toggle();*/

          /*this.toggleFailed();*/
          /*alert("Bin Master Successfully Created");*/
          // this.fetchBinData();
        })
        .catch(function (error) {});
    }

    /* this.toggleFailed();*/
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem);
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;

    const data = {
      columns: [
        {
          label: "Bin ID",

          field: "bin_id",
          sort: "asc",
        },

        {
          label: "Storage Type",

          field: "storage_type",
          sort: "asc",
        },

        {
          label: "Aisle",

          field: "aisle",
          sort: "asc",
        },

        {
          label: "Rack",

          field: "rack",
          sort: "asc",
        },

        {
          label: "Rack Type",

          field: "rack_type",
          sort: "asc",
        },

        {
          label: "Level",

          field: "level",
          sort: "asc",
        },

        {
          label: "BIN",

          field: "bin",
          sort: "asc",
        },

        {
          label: "Zone Name",

          field: "zone_name",
          sort: "asc",
        },

        {
          label: "Zone No.",

          field: "zone_no",
          sort: "asc",
        },
      ],

      rows: this.state.tableRows,
    };

    const baseData = {
      columns: [
        {
          label: "Base Pack Code",

          field: "base_pack_code",
        },

        {
          label: "zoneName",

          field: "zone_name",
        },

        {
          label: "zoneNumber",

          field: "zone_number",
        },
        {
          label: "Product Type",

          field: "productType",
        },
      ],

      rows: this.state.tableRowsBase,
    };

    const productData = {
      columns: [
        {
          label: "Company",

          field: "company",
          width: 130,
        },

        {
          label: "Brand",

          field: "brand",
          width: 130,
        },

        {
          label: "Sub Brand",

          field: "sub_brand",
          width: 150,
        },

        {
          label: "IB Sku Id",

          field: "ib_sku_id",
          width: 150,
        },

        {
          label: "IB Sku Product Name",

          field: "ib_sku_product_name",
          width: 270,
        },

        {
          label: "Base Pack Code",

          field: "base_pack_code",
          width: 130,
        },

        {
          label: "CBU Code",

          field: "cbu_code",
          width: 130,
        },

        {
          label: "Shade Code",

          field: "shade_code",
          width: 130,
        },

        {
          label: "Shade Name",

          field: "shade_name",
          width: 170,
        },

        {
          label: "Category",

          field: "category",
          width: 180,
        },

        {
          label: "Sub-Category",

          field: "sub_category",
          width: 180,
        },

        {
          label: "Price Lot",

          field: "price_lot",
          width: 180,
        },

        {
          label: "MRP",
          field: "mrp",
          width: 150,
        },

        {
          label: "UOM",
          field: "uom",
          width: 150,
        },
        {
          label: "UPC",
          field: "upc",
          width: 150,
        },

        {
          label: "Pack Size",
          field: "pack_size",
          width: 180,
        },

        {
          label: "Pack Size UO",

          field: "pack_size_uo",
          width: 150,
        },

        {
          label: "EAN",

          field: "ean",
          width: 150,
        },

        {
          label: "ICLD EAN",

          field: "icld_ean",
          width: 150,
        },

        {
          label: "Weight",

          field: "weight",
          width: 180,
        },

        {
          label: "Volume",

          field: "volume",
          width: 150,
        },

        {
          label: "ICLD Volume",

          field: "icldVolume",
          width: 150,
        },

        {
          label: "SKU7 Code",

          field: "sku7Code",
          width: 180,
        },

        {
          label: "SKU5 Code",

          field: "sku5Code",
          width: 180,
        },

        {
          label: "Offer",

          field: "offer",
          width: 180,
        },

        {
          label: "Tester",

          field: "tester",
          width: 150,
        },

        {
          label: "Storage Type",

          field: "storageType",
          width: 150,
        },

        {
          label: "Status",

          field: "status",
          width: 150,
        },

        {
          label: "Created Date Time",

          field: "createdDateTime",
          width: 180,
        },

        {
          label: "Outer Carton EAN",

          field: "outerCartonEAN",
          width: 180,
        },
        {
          label: "CPO",

          field: "cpo",
          width: 180,
        },
        {
          label: "Carton Length",

          field: "cartonLength",
          width: 180,
        },
        {
          label: "Carton Breadth",

          field: "cartonBreadth",
          width: 180,
        },
        {
          label: "Carton Height",

          field: "cartonHeight",
          width: 180,
        },
        {
          label: "Carton Volumne",

          field: "cartonVolume",
          width: 180,
        },
        {
          label: "OCLD Applicable",

          field: "ocldApplicable",
          width: 180,
        },
      ],

      rows: this.state.tableRowsProduct,
    };

    const testerData = {
      columns: [
        {
          label: "BasePack Code",

          field: "base_pack_code",
          sort: "asc",
        },

        {
          label: "Bin Address",

          field: "bin",
          sort: "asc",
        },
      ],

      rows: this.state.tableRowsTester,
    };

    return (
  
      <Col xl={12}>
      {/*<div class="overlay">
    <div class="overlay__inner">
      <div class="overlay__content"><span class="spinner"></span></div>
    </div>
      </div>*/}
      {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody style={{height: 220}}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "none" }}
              >
                <span
                  className="form__form-group-label col-xl-4"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Master
                </span>

                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select Master"
                    value={selectedOption}
                    onChange={this.change}
                    options={[
                      { value: "bin_master", label: "Bin Master" },
                      {
                        value: "base_pack_zone",
                        label: "Basepack Zone Master",
                      },
                      { value: "product_master", label: "Product Master" },
                      {
                        value: "tester_basepack_master",
                        label: "Tester Basepack Master",
                      },
                    ]}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                     
                      id="my_file_input"
                      onChange={this.handleChange}
            ref={ref=> this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload Alternate Product Master
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
          disabled ={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>

         

            
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.basepack_header,
                      "Alternate_Product_Master_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                
              </div>
           

          

          
          </CardBody>

          {/*this.state.showZoneConfigCard &&
          <CardBody style={{ marginTop: 20 }}>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
        {<input
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonecode"
                  type="text"
                  placeholder="Zone Code"
                  id="config_zonecode"
                  onChange={this.configOnChangeHandler}
        />}
        <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonecode"
                  placeholder="Configuration"
                  id="config_zonecode"
                  onChange={this.configOnChangeHandler}
                >
                <option value="" disabled selected hidden>-Select zone-</option>
                {this.state.zoneOptions.map(zone =>
                  <option value={zone.value}>{zone.label}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
        <input
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonename"
                  type="text"
                  placeholder="Zone Name"
                  id="config_zonename"
                  onChange={this.configOnChangeHandler}
        />
              </div>
            </div>

            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonetype"
                  placeholder="Type"
                  id="config_zonetype"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Type-</option>
        {this.state.zoneTypeDropdown.map(zone =>
                  <option value={zone.id}>{zone.zone_type}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "0px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zoneconfig"
                  placeholder="Configuration"
                  id="config_zoneconfig"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Config-</option>
                {this.state.zoneConfigDropdown.map(config =>
                  <option value={config.id}>{config.config_code}</option>
        )}
                </select>
              </div>
            </div>
      <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_basepackcode"
                  placeholder="Configuration"
                  id="config_basepackcode"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Basepack-</option>
                {this.state.configBaskPackDropdown.map(basepack =>
                  <option value={basepack}>{basepack}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_producttype"
                  placeholder="Configuration"
                  id="config_producttype"
                  onChange={this.configOnChangeHandler}
                >
                <option value="" disabled selected hidden>-Select Product Type-</option>
                <option value="0">Saleable</option>
        <option value="1">Carton</option>
        <option value="2">Tester</option>
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <ButtonToolbar className="form__button-toolbar">
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={this.createZoneConfig}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Create
                </button>
              </ButtonToolbar>
            </div>
          </CardBody>
      */}
          {this.state.showRowDataError && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again.{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Bin"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok show_bin_proceed"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBinData.failure_response.length > 0 &&
                    this.state.responseFailBinData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBinData.success_response.length >
                    0 &&
                    this.state.responseSuccessBinData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">BIN MASTER</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.posts, "BinMaster")}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            data={data}
          />
          </CardBody>

          )}*/}

          {this.state.showRowDataErrorBase && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Basepack Code"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidBaseItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    {" "}
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>{" "}
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBaseData.failure_response.length >
                    0 &&
                    this.state.responseFailBaseData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBaseData.success_response.length >
                    0 &&
                    this.state.responseSuccessBaseData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchBaseData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> BASE PACK MASTER</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBase, "BasepackMaster")}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            data={baseData}
          />
          </CardBody>

          )}*/}

          {this.state.showRowDataErrorProduct && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["LB SKU ID"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidProductItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                   {/* <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button> */}
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Parent SKU</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailProductData.length >
                    0 &&
                    this.state.responseFailProductData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.sku7_code}</td>
                          {item.success == false &&
                             <td style={{ color: "red"}}>{item.message}</td>
                          }
                          {item.success == true &&
                             <td style={{ color: "green"}}>{item.message}</td>
                          }
                         
                        </tr>
                      )
                    )}

                 
                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchProductData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Product Master</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsProduct, "ProductMaster")}>Download Excel</Button>
            </div>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={productData}
          />

          </CardBody>

          )}*/}

          {this.state.showRowDataErrorTester && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["LB SKU ID"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidTesterItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailTesterData.failure_response.length >
                    0 &&
                    this.state.responseFailTesterData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessTesterData.success_response
                    .length > 0 &&
                    this.state.responseSuccessTesterData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/* {
            this.state.showFetchTesterData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Tester BasePack Master</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsTester, "TesterFile")}>Download Excel</Button>
            </div>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={testerData}
          />

          </CardBody>

          )}*/}
        </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.togglePressCancel}
            >
              Ok
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.togglePressCancel}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{ maxWidth: 456 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.ConfirmToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4 style={{ fontSize: 18 }}> Are you sure you want to proceed?</h4>
            <br />
            <h3 style={{ fontSize: 17 }}>
              <strong> NOTE: </strong> Duplicate entries will be updated if you
              proceed.{" "}
            </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                marginRight: 8,
              }}
              className="modal_ok"
              onClick={this.processData}
            >
              Ok
            </Button>
            <button
              className="modal_cancel"
              onClick={this.ConfirmToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>
    
    <Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.responseModalToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>
    
    
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));